import {ComumService} from './../../comum/comum.service';
import {Evento} from './../../comum/eventos/evento';
import {Paginacao} from '../../comum/modelos/paginacao';
import {Dashboard} from '../../comum/modelos/dashboard';
import {DashboardsService} from './../dashboards.service';
import {Component, OnInit, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-layout-grafico',
  templateUrl: './layout-grafico.component.html',
  styleUrls: ['./layout-grafico.component.css']
})
export class LayoutGraficoComponent implements OnInit {
  @Output() parametrosGraficoEvent: EventEmitter<String>;

  dashboards: Dashboard[];

  filtroPesquisaNomeVisaoBind: string;

  paginacao: Paginacao;

  evento: Evento;

  dataInicioReferencia: Date;
  dataFimReferencia: Date;

  public loading = false;
  public statusCode: number;

  constructor(private _dashboardsService: DashboardsService,
    private _comumService: ComumService) {

    this.paginacao = new Paginacao();
    this.parametrosGraficoEvent = new EventEmitter<String>();
    this.evento = this._comumService.evento;

    if (this.evento !== undefined) {
      setTimeout(() => {
        this._comumService.cleanEvent();
      }, 3000);
    }

  }

  ngOnInit() {
    this.paginacao.itens = 5;
    this.paginacao.page = 1;
  }

  pesquisarPorFiltro(filtro: any): void {
    this.filtroPesquisaNomeVisaoBind = filtro.value;
  }

  limparPesquisaPorFiltro(filtro: any): void {
    filtro.value = '';
    this.pesquisarPorFiltro(filtro);
  }

  removerDashboard(dashboard: Dashboard): void {}

  salvar(): void {
    this.parametrosGraficoEvent.emit('pie');
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/dashboards/layout-grafico/layout-grafico.component.ts